export default function (context, settings) {
    context.state.masterAgentSettings = settings;
}
